import { MajorServiceClassification } from '../major-service-classification';
import { TestedParty } from '../tested-party';

export class MajorClassificationsModalPayload {
  testedParty: TestedParty;
  testedPartyMajorClassifications: MajorServiceClassification[];
  allMajorServiceClassifications: MajorServiceClassification[];
}
